import MyPagesFormConfig from '../../../../form/shared/mypages/config'

export default MyPagesFormConfig
